import React from 'react';
import MessengerInterface from '../components/MessengerInterface';

const MessagesPage = () => {
  return (
    <div className="-mx-4 sm:-mx-6 lg:-mx-8 -my-4 sm:-my-6 lg:-my-8 h-[calc(100vh-4rem)]">
      <MessengerInterface />
    </div>
  );
};

export default MessagesPage;
